var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.39465 4.3934C5.78753 3.00052 7.44112 1.89563 9.261 1.14181C11.0809 0.387986 13.0314 -2.09096e-07 15.0013 0C16.9711 2.09096e-07 18.9216 0.387987 20.7415 1.14181C22.5614 1.89563 24.215 3.00052 25.6079 4.3934C27.0007 5.78628 28.1056 7.43987 28.8594 9.25975C29.6133 11.0796 30.0013 13.0302 30.0013 15C30.0013 16.9698 29.6133 18.9204 28.8594 20.7403C28.1056 22.5601 27.0007 24.2137 25.6079 25.6066L4.39465 4.3934Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.51594 23.4853C11.2022 28.1716 18.8002 28.1716 23.4865 23.4853C28.1728 18.799 28.1728 11.201 23.4865 6.51472C18.8002 1.82843 11.2022 1.82843 6.51594 6.51472C1.82965 11.201 1.82965 18.799 6.51594 23.4853ZM4.39462 25.6066C10.2525 31.4645 19.75 31.4645 25.6078 25.6066C31.4657 19.7487 31.4657 10.2513 25.6078 4.3934C19.75 -1.46447 10.2525 -1.46447 4.39462 4.3934C-1.46325 10.2513 -1.46325 19.7487 4.39462 25.6066Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5974 10.4038C20.1832 10.9896 20.1832 11.9394 19.5974 12.5252L12.5263 19.5962C11.9405 20.182 10.9908 20.182 10.405 19.5962C9.81923 19.0104 9.81923 18.0607 10.405 17.4749L17.4761 10.4038C18.0619 9.81804 19.0116 9.81804 19.5974 10.4038Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5973 19.5961C19.0115 20.1819 18.0618 20.1819 17.476 19.5961L10.4049 12.5251C9.81912 11.9393 9.81913 10.9895 10.4049 10.4037C10.9907 9.81795 11.9404 9.81795 12.5262 10.4037L19.5973 17.4748C20.1831 18.0606 20.1831 19.0103 19.5973 19.5961Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExit);
export default __webpack_public_path__ + "static/media/ic_exit.3e4484de82a3aa01ce10adeaca444a97.svg";
export { ForwardRef as ReactComponent };